var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#C2C2C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0984 7.07251H8.90039V8.46087C8.90039 10.6659 10.2993 12.5417 12.2567 13.253C12.5465 13.3583 12.7388 13.6297 12.7388 13.9379C12.7388 14.2462 12.5465 14.5175 12.2567 14.6229C10.265 15.3474 8.85034 17.2811 8.90302 19.5335V20.9456H19.101V19.415C19.101 17.2099 17.7021 15.3342 15.7447 14.6229C15.4549 14.5175 15.2626 14.2462 15.2626 13.9379C15.2626 13.6297 15.4549 13.3583 15.7447 13.253C17.7364 12.5285 19.1511 10.5948 19.0984 8.34232C19.0984 8.34232 19.0589 7.11203 19.0984 7.07251Z",
    fill: "#50B2C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6036 16.8729H15.8844C15.1599 16.8729 14.7357 16.2854 14.7357 15.5635L14.5724 14.2621C14.5724 13.8801 14.8042 13.5534 15.1362 13.4138C15.2468 13.3664 15.6815 13.2742 15.7421 13.2505C15.858 13.2083 15.9739 13.1609 16.0872 13.1108C17.2306 12.5971 18.15 11.675 18.6585 10.5291H9.33771C9.85143 11.6856 10.784 12.6156 11.9432 13.124C12.0459 13.1688 12.6993 13.369 12.8178 13.427C13.1313 13.5745 13.3474 13.8933 13.3474 14.2621L13.2578 15.5635C13.2578 16.288 12.7625 16.8729 12.038 16.8729H11.3952C10.0437 16.8729 8.92937 17.9503 8.90039 19.3018C8.90039 19.3782 8.90039 19.4546 8.90039 19.5337V20.9457H19.0984V19.4151C19.0984 19.373 19.0984 19.3308 19.0984 19.286C19.0642 17.9398 17.9498 16.8729 16.6036 16.8729Z",
    fill: "#FFC300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 20.9458V7.07007H8.90039V8.45843C8.90039 10.6635 10.2993 12.5392 12.2567 13.2505C12.5465 13.3559 12.7388 13.6273 12.7388 13.9355C12.7388 14.2437 12.5465 14.5151 12.2567 14.6205C10.265 15.3449 8.85034 17.2786 8.90302 19.5311V20.9432H14.0007V20.9458Z",
    fill: "#317984"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.9275H8V23.0904H20V20.9275Z",
    fill: "#29292E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.90991H8V7.07281H20V4.90991Z",
    fill: "#29292E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.002 20.9455V10.5315H9.34162C9.85534 11.688 10.7879 12.618 11.9471 13.1264C12.0499 13.1712 12.7032 13.3715 12.8218 13.4294C13.1353 13.5769 13.3513 13.8957 13.3513 14.2645L13.2617 15.566C13.2617 16.2904 12.7664 16.8753 12.0419 16.8753H11.3991C10.0477 16.8753 8.93328 17.9528 8.9043 19.3043C8.9043 19.3807 8.9043 19.4571 8.9043 19.5361V20.9482H14.002V20.9455Z",
    fill: "#E48F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeWaiting);
export default __webpack_public_path__ + "static/media/Type=Waiting.ebce209d9f4b3726dcb7802452814e7b.svg";
export { ForwardRef as ReactComponent };